import Entity from "./Entity";
import IUser from "./User";

export default interface ITransfer extends Entity {
	zoopId?: string;
	value?: string | any;
	bankCode?: string;
	bankName?: string;
	agency?: string;
	checking?: string;
	status?: TransferStatus | any;
	statusText?: string;
	user?: IUser | any;
	to?: string;
	type?: TransferType | any;
}

export enum TransferStatus {
	Pending = 0,
	Done = 1,
	Failed = 2,
	Canceled = 3
}

export enum TransferType {
	BankAccount = 0,
	P2P = 1
}
